import React from "react";
import { Eye, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useTitanApp } from "@/hooks/useTitanApp";
import { setPreviewPrescription } from "@/dispatchers/patientPrescriptionDispatcher";
import { Skeleton } from "@mui/material";

export function PrescriptionImagePreviewModal({}) {
  const handleDownload = () => {
    if (!consultationPrescriptionImagePreview) return;

    const link = document.createElement("a");
    link.href = consultationPrescriptionImagePreview;
    link.download = "prescription.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const {appState, patientPrescriptionState } = useTitanApp();
  const {
    previewPrescription,
    consultationPrescriptionImagePreview,
    showPrintPreviewLoading,
  } = patientPrescriptionState || {};
    const { darkMode } = appState;
  
  return (
    <Dialog
      open={previewPrescription}
      onOpenChange={() => setPreviewPrescription(false)}
    >
      <DialogContent className="pres-modal max-w-4xl max-h-[170vh] p-0">
        <DialogHeader className="p-6 pb-4">
          <DialogTitle className="flex items-center gap-2">
            <Eye className="w-5 h-5 text-blue-600" />
            Prescription Image Preview 
          </DialogTitle>
        </DialogHeader>
        <div className="px-6 pb-6">
          {showPrintPreviewLoading ? (
            <div className="p-4 space-y-4">
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    width="100%"
                    height={500}
                    className="rounded-lg"
                    sx={{ bgcolor: darkMode ? "grey.800" : ""} }
                  />
                </div>
          ) : (
            <div className="relative overflow-y-auto max-h-[75vh] custom-scrollbar">
              <img
                src={consultationPrescriptionImagePreview || ""}
                alt="Prescription"
                className="w-full h-auto max-h-[170vh] object-contain rounded-lg border border-gray-200"
              />
              <div className="mt-4 flex justify-end gap-2">
                <Button variant="outline" onClick={handleDownload}>
                  <Download className="w-4 h-4 mr-2" />
                  Download
                </Button>
                <Button
                  variant="outline"
                  onClick={() => setPreviewPrescription(false)}
                >
                  Close
                </Button>
              </div>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
